import { Box, Grid } from '@mui/material';
import { VerifyFormData } from 'modules/auth/types';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { FormComponentProps, FormTextBox } from 'shared/components';
import { useLangContext } from 'shared/features/Language';
import { COUPON_PATTERN, useAppUrlBuilderContext } from 'shared/tools';
import {CustomButton} from "../../../../shared/components/Buttons/CustomButton";
import './style.scss';

export const VerifyForm: FC<FormComponentProps<VerifyFormData, { isLoading: boolean }>> = ({
  form,
  isLoading,
}) => {
  const appUrlBuilder = useAppUrlBuilderContext();
  const { textData } = useLangContext();

  const couponAutoFormat = (coupon: string): string => {
    const code = coupon.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    const part1 = code.slice(0, 4);
    const part2 = code.slice(4, 8);
    return [part1, part2].filter(Boolean).join('-');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box>
        <FormTextBox
          actionOnChange={e => (e.target.value = couponAutoFormat(e.target.value))}
          form={form}
          placeholder={textData.uniqueCodePlaceholder}
          fieldName="code"
          validation={{
            required: textData.requiredCode,

            pattern: {
              value: COUPON_PATTERN,
              message: textData.invalidCode,
            },
          }}
          isDisabled={isLoading}
          styles={{
            width:{lg: '650px', md:'600px', xs:'auto'},
            margin: {lg: '50px auto 50px', md: '50px auto 50px', xs:'30px auto'},
          }}
          className="verify-input-wrapper"
        />
      </Box>
        <Grid container
              sx={{
                gap: {lg: '100px', md: '50px', xs: '20px'},
                width: '100%',
                justifyContent: 'center',
              }}
        >
          <Grid item>
            <Link to={appUrlBuilder.home()}>
              <CustomButton
                // type="button"
                disabled={isLoading}
                color="secondary"
                width={{ lg: '250px', xs: '150px' }}
              >
                  {textData.buttonCaptionBack}
              </CustomButton>
            </Link>
          </Grid>
          <Grid item>
            <CustomButton
              // type="submit"
              width={{ lg: '250px', xs: '150px' }}
            >
                {textData.buttonCaptionNext}
            </CustomButton>
          </Grid>
      </Grid>
    </Box>
  );
};
